<template>
  
    <el-container>
     
      <el-main>
       <h1>常用快捷操作</h1>
        <h3>从桌面拖动图片到思维导图</h3>
         <div>
          <img src="../assets/markmind/image.gif" alt="" width="800">
       </div>
 
        <h3>从浏览器中复制文本到思维导图</h3>
         <div>
          <img src="../assets/markmind/text.gif" alt="" width="800">
       </div>

        <h3>批量移动节点</h3>  
         <div>
          <img src="../assets/markmind/nodes.gif" alt="" width="800">
       </div>
      
      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'shortcutPage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
